<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiCancel } from "@mdi/js";
export default {
  name: "MdiCancel",
  data() {
    return {
      svgPath: mdiCancel,
    };
  },
};
</script>
